import React, { Component } from 'react'
import { CustomModal } from './Modal'
import { uniqBy } from 'lodash'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { getReferences, getAttendanceModeCodesDetails, getAttendanceModeDescription } from '../../../services/vu'


class ChooseDeliveryModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      ...this.getInitialModalState(),
      attendanceModeList: []
    }
  }

  componentDidMount(){
    Promise.all([getAttendanceModeCodesDetails()]).then(([attendanceModeList]) => {
      this.setState({
        attendanceModeList : attendanceModeList.referenceCodes
      })
    })
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.isOpen &&
      this.props.units !== prevProps.units &&
      this.props.units.length !== 0
    ) {
      this.setState(this.getInitialModalState())
    }


  }

  getInitialModalState = () => ({
    modelKeyNumber: '',
    modelAttendanceMode: ''
  })

  getDeliveryModeOptions = () => {
    return uniqBy(this.props.units, 'unitAvailabilityAttendanceModeCode').map(
      unit => ({
        value: unit.unitAvailabilityAttendanceModeCode,
        label:
          unit.unitAvailabilityLocationDescription +
          '-' +
          getAttendanceModeDescription(this.state.attendanceModeList,unit.unitAvailabilityAttendanceModeCode)
      })
    )
  }

  handleSubmitUnit = () => {
    const unit = this.props.units.find(unit => {
      return (
        unit.unitAvailabilityAttendanceModeCode ===
        this.state.modelAttendanceMode
      )
    })

    if (unit) {
      this.props.handleSubmitUnit(unit)
    } else {
      this.props.dispatchError(
        'Unable to find a unit with the selected parameters.'
      )
    }
  }

  render() {
    if (!this.props.isOpen) {
      return null
    }

    return (
      <CustomModal
        isOpen={this.props.isOpen}
        handleCloseModal={() => this.props.handleCloseModal()}
        title={this.props.title}
      >
        {this.props.loading ? (
          <div className="question-group">Loading...</div>
        ) : (
          <div className="question-group" style={{paddingBottom: 8}}>
            <div>
              <FormControl>
                <InputLabel>Delivery Mode</InputLabel>
                <Select
                  name="Delivery Mode"
                  options={this.getDeliveryModeOptions()}
                  onChange={event => {
                    this.setState({
                      modelAttendanceMode: event.target.value
                    })
                  }}
                  value={this.state.modelAttendanceMode}
                >
                  {
                    this.getDeliveryModeOptions().map(option =>
                      <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                    )
                  }
                </Select>
              </FormControl>
             
            </div>
          </div>
        )}

        <button
          clclassNameass="btn btn-primary btn-lg"
          disabled={!this.state.modelAttendanceMode || this.props.submitting}
          onClick={this.handleSubmitUnit}
        >
          {this.props.submitting
            ? this.props.buttonLoadText
            : this.props.buttonText}
        </button>
      </CustomModal>
    )
  }
}

export default ChooseDeliveryModal
